import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deletePost, loadingSet } from "../store/actions/postActions";
import Swal from "sweetalert2";

export default function PostRow({ post, index }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const deletePostHandler = (postId) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(deletePost(postId))
					.then(() => {
						Swal.fire({
							position: "top-end",
							icon: "success",
							title: "successfully deleted news",
							showConfirmButton: false,
							timer: 1000,
						});
					})
					.catch((err) => {
						return Swal.fire({
							icon: "error",
							title: "Error",
							text: err,
						});
					})
					.finally(() => {
						dispatch(loadingSet(false));
					});
			}
		});
	};

	const editPost = (postId) => {
		navigate(`/posts/edit-post/${postId}`);
	};

	return (
		<tr className="text-center align-middle">
			<td>{index + 1}</td>
			<td style={{ maxWidth: "300px" }}>{post.title}</td>
			<td className="text-truncate" style={{ maxWidth: "300px" }}>
				{post.content}
			</td>
			<td>
				<img src={post.imgUrl} style={{ width: "100px" }} alt="Post" />
			</td>
			<td>{post.Category.name}</td>
			<td>{post.User.username}</td>
			<td>
				<button onClick={() => editPost(post.id)} className="btn me-1">
					Edit
				</button>
				<button onClick={() => deletePostHandler(post.id)} className="btn">
					Delete
				</button>
			</td>
		</tr>
	);
}
